import { render, staticRenderFns } from "./AltEsignAnswer.vue?vue&type=template&id=65a78112&"
import script from "./AltEsignAnswer.vue?vue&type=script&lang=js&"
export * from "./AltEsignAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AltEsignAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports